import { Component, Input, inject } from '@angular/core';
import { AffordabilityServiceState } from '../../models';
import { AffordabilityService } from '../../services';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-results-circle',
  templateUrl: './results-circle.component.html',
  styleUrls: ['./results-circle.component.scss'],
  imports: [CurrencyPipe],
})
export class ResultsCircleComponent {
  public readonly affordabilityService = inject(AffordabilityService);

  @Input() public amount: number;
  @Input() public monthlyAmount: number;

  public get errored() {
    return this.affordabilityService.state === AffordabilityServiceState.Errored;
  }
}
